module.exports = __webpack_public_path__ + "img/blue-clock.515fb922.svg";